/* DOXCORA cart drawer layer.
   Built against Dawn's <cart-drawer>. Horizon ships its own cart architecture
   (<cart-drawer-component> + theme blocks), so this layer stands down there
   rather than half-running and corrupting Horizon's drawer. The Horizon-native
   rebuild is a separate piece of work. */
if (!document.querySelector('cart-drawer') && document.querySelector('cart-drawer-component')) {
  console.info('[DOXCORA] Horizon cart detected — legacy Dawn cart layer disabled.');
} else {
(function () {
  'use strict';
  /* DOXCORA drawer extras. Extends Dawn's cart-drawer; Dawn keeps ownership of
     line items, quantity, remove and checkout. All money that needs formatting
     is rendered by Liquid in the dox-cart-blocks section and pulled in here, so
     Shopify Markets stays correct. /cart.js is the only source of truth. */

  /* Section Rendering API keys by section ID, not by type. In
     footer-group.json this section's ID is dox_cart. */
  var SEC = 'dox_cart';
  var CFG = {};
  var busy = false;

  function q(s, r) { return (r || document).querySelector(s); }
  function drawer() { return q('cart-drawer'); }
  function inner() { var d = drawer(); return d ? q('.drawer__inner', d) : null; }
  function money(c) {
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency', currency: CFG.currency || 'USD',
        minimumFractionDigits: (c / 100) % 1 === 0 ? 0 : 2
      }).format((c || 0) / 100);
    } catch (e) { return ((c || 0) / 100).toFixed(2); }
  }

  function api(url, opt) {
    return fetch(url, Object.assign({ credentials: 'same-origin' }, opt || {}));
  }
  function getCart() {
    return api('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function post(url, body) {
    return api(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }
  var addUrl = function () { return (window.routes && window.routes.cart_add_url) || '/cart/add'; };
  var chgUrl = function () { return (window.routes && window.routes.cart_change_url) || '/cart/change'; };

  function lineFor(cart, vid) {
    if (!vid) return null;
    for (var i = 0; i < cart.items.length; i++) {
      if (String(cart.items[i].variant_id) === String(vid)) return cart.items[i];
    }
    return null;
  }
  /* Cart total excluding the gift and the protection line. */
  function netTotal(cart) {
    var t = cart.total_price;
    [CFG.gift_variant, CFG.prot_variant].forEach(function (v) {
      var l = v ? lineFor(cart, v) : null;
      if (l) t -= l.final_line_price;
    });
    return Math.max(0, t);
  }

  /* ---------- pull freshly rendered Liquid blocks ---------- */
  function fetchBlocks() {
    return api(window.location.pathname + '?sections=' + SEC)
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var html = j[SEC] || j[Object.keys(j)[0]];
        if (!html) return null;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var src = q('[data-dox-blocks]', doc);
        if (!src) return null;
        var cfgEl = q('[data-dox-cart-config]', src);
        if (cfgEl) { try { Object.assign(CFG, JSON.parse(cfgEl.textContent)); } catch (e) {} }
        return src;
      })
      .catch(function () { return null; });
  }

  function applyVars() {
    var d = drawer();
    if (!d) return;
    if (CFG.width) d.style.setProperty('--dox-cart-w', CFG.width + 'px');
    Object.keys(CFG.css || {}).forEach(function (k) { d.style.setProperty(k, CFG.css[k]); });
  }

  /* ---------- progress bar with gift + shipping milestones ---------- */
  function buildShip(cart, box) {
    var el = q('.dox-ship', box);
    if (!CFG.ship_enabled || !CFG.ship_threshold) { if (el) el.remove(); return; }
    if (!el) {
      el = document.createElement('div');
      el.className = 'dox-ship';
      el.innerHTML =
        '<p class="dox-ship__msg" role="status"></p>' +
        '<div class="dox-ship__track"><span class="dox-ship__fill"></span>' +
        '<span class="dox-ship__pin dox-ship__pin--gift" hidden></span>' +
        '<span class="dox-ship__pin dox-ship__pin--end">&#9673;</span></div>' +
        '<div class="dox-ship__labels"><span data-gift-label></span><span data-ship-label></span></div>';
      var h = q('.drawer__header', box);
      var an = q('.dox-an', box);
      var after = an || h;
      after.parentNode.insertBefore(el, after.nextSibling);
    }
    var total = netTotal(cart);
    var goal = CFG.ship_threshold;
    var left = Math.max(0, goal - total);
    el.classList.toggle('dox-ship--done', left === 0);
    q('.dox-ship__msg', el).textContent = left === 0
      ? (CFG.ship_success || '')
      : (CFG.ship_progress || '').replace('[amount]', money(left));
    q('.dox-ship__fill', el).style.width = Math.min(100, (total / goal) * 100) + '%';

    var gp = q('.dox-ship__pin--gift', el);
    var gl = q('[data-gift-label]', el);
    if (CFG.gift_enabled && CFG.gift_threshold > 0 && CFG.gift_threshold < goal) {
      var at = (CFG.gift_threshold / goal) * 100;
      gp.hidden = false;
      gp.style.left = at + '%';
      gp.classList.toggle('is-hit', total >= CFG.gift_threshold);
      gl.textContent = CFG.gift_label || '';
      gl.style.left = at + '%';
    } else { gp.hidden = true; gl.textContent = ''; }
    q('[data-ship-label]', el).textContent = CFG.ship_label || '';
  }

  /* ---------- move Liquid-rendered blocks into place ---------- */
  function place(box, src, sel, anchor, before) {
    var old = q(sel, box);
    if (old) old.remove();
    var node = src ? q(sel, src) : null;
    if (!node || !anchor) return;
    node = node.cloneNode(true);
    if (before) anchor.parentNode.insertBefore(node, anchor);
    else anchor.parentNode.insertBefore(node, anchor.nextSibling);
  }

  function badgeGift(box, cart) {
    if (!CFG.gift_variant) return;
    var line = lineFor(cart, CFG.gift_variant);
    if (!line) return;
    // Dawn renders each row with an id ending in the 1-based line index.
    var row = q('#CartDrawer-Item-' + (cart.items.indexOf(line) + 1), box);
    if (!row || q('.dox-gift-badge', row)) return;
    var t = q('.cart-item__title', row) || q('.cart-item__details', row);
    if (!t) return;
    var b = document.createElement('span');
    b.className = 'dox-badge dox-gift-badge';
    b.textContent = CFG.gift_badge || 'Free Gift';
    t.appendChild(b);
    row.classList.add('dox-is-gift');
  }

  function buildFooter(box, cart) {
    var f = q('.drawer__footer', box);
    if (!f) return;
    var row = q('.dox-tot', f);
    if (!row) {
      row = document.createElement('div');
      row.className = 'dox-tot';
      f.insertBefore(row, f.firstChild);
    }
    var disc = cart.original_total_price - cart.total_price;
    row.innerHTML =
      '<span class="dox-tot__l">' + (CFG.total_label || 'Total') + ': ' + cart.item_count + ' Items</span>' +
      '<span class="dox-tot__r">' +
      (disc > 0 ? '<span class="dox-tot__off">-' + money(disc) + '</span>' : '') +
      (disc > 0 ? '<s>' + money(cart.original_total_price) + '</s>' : '') +
      '<strong>' + money(cart.total_price) + '</strong></span>';
    var btn = q('#CartDrawer-Checkout', f);
    if (btn && CFG.checkout_label) btn.textContent = CFG.checkout_label;
  }

  /* ---------- gift auto add / remove ---------- */
  function syncGift(cart) {
    if (!CFG.gift_enabled || !CFG.gift_variant || busy) return null;
    var line = lineFor(cart, CFG.gift_variant);
    var earned = netTotal(cart) >= CFG.gift_threshold && cart.item_count > 0;
    if (earned && !line) return post(addUrl(), { items: [{ id: CFG.gift_variant, quantity: 1 }] });
    if (!earned && line) return post(chgUrl(), { id: line.key, quantity: 0 });
    return null;
  }

  /* ---------- render ---------- */
  function render() {
    var box = inner();
    if (!box) return Promise.resolve();
    return Promise.all([getCart(), fetchBlocks()]).then(function (r) {
      var cart = r[0], src = r[1];
      if (!cart || !cart.items) return;
      CFG.currency = cart.currency;
      applyVars();

      var gift = syncGift(cart);
      if (gift) { busy = true; return gift.then(function () { busy = false; return repaint(); }); }

      var h = q('.drawer__header', box);
      if (h) {
        var hd = q('.drawer__heading', box);
        if (hd && !q('.dox-cart__count', hd)) {
          var c = document.createElement('span');
          c.className = 'dox-cart__count';
          hd.appendChild(c);
        }
        var cs = q('.dox-cart__count', box);
        if (cs) cs.textContent = cart.item_count;
        place(box, src, '.dox-an', h);
      }
      buildShip(cart, box);

      var items = q('cart-drawer-items', box);
      var foot = q('.drawer__footer', box);
      if (items) place(box, src, '[data-dox-upsells]', items);
      if (foot) place(box, src, '.dox-prot', foot, true);
      badgeGift(box, cart);
      buildFooter(box, cart);
      if (foot) {
        var pay = q('.dox-pay', foot);
        if (pay) pay.remove();
        var np = src ? q('.dox-pay', src) : null;
        if (np) foot.appendChild(np.cloneNode(true));
      }
      // Hide upsells already in the cart.
      Array.prototype.forEach.call(box.querySelectorAll('[data-dox-up]'), function (u) {
        u.hidden = !!lineFor(cart, u.getAttribute('data-variant'));
      });
      var sw = q('.dox-prot__switch', box);
      if (sw) {
        var pl = lineFor(cart, CFG.prot_variant);
        sw.setAttribute('aria-checked', pl ? 'true' : 'false');
        sw.dataset.line = pl ? pl.key : '';
      }
    });
  }

  /* Repaint through Dawn's own Section Rendering path, then re-apply extras. */
  function repaint() {
    var d = drawer();
    if (!d || typeof d.getSectionsToRender !== 'function') return render();
    var list = d.getSectionsToRender();
    return api(window.location.pathname + '?sections=' + list.map(function (s) { return s.id; }).join(','))
      .then(function (r) { return r.json(); })
      .then(function (sec) {
        list.forEach(function (s) {
          var el = s.selector ? q(s.selector) : document.getElementById(s.id);
          if (el && sec[s.id]) el.innerHTML = d.getSectionInnerHTML(sec[s.id], s.selector);
        });
      })
      .then(render)
      .catch(function () {});
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var up = e.target.closest('[data-dox-up-add]');
    if (up && !busy) {
      busy = true; up.disabled = true;
      post(addUrl(), { items: [{ id: up.getAttribute('data-variant'), quantity: 1 }] })
        .then(function () { busy = false; return repaint(); })
        .catch(function () { busy = false; });
      return;
    }
    var sw = e.target.closest('.dox-prot__switch');
    if (sw && !busy) {
      busy = true; sw.disabled = true;
      var on = sw.getAttribute('aria-checked') === 'true';
      (on ? post(chgUrl(), { id: sw.dataset.line, quantity: 0 })
          : post(addUrl(), { items: [{ id: CFG.prot_variant, quantity: 1 }] }))
        .then(function () { busy = false; return repaint(); })
        .catch(function () { busy = false; });
    }
  });

  function watch() {
    var host = document.getElementById('CartDrawer');
    if (!host) return;
    var t;
    new MutationObserver(function () {
      if (busy) return;
      clearTimeout(t);
      t = setTimeout(function () { render(); }, 70);
    }).observe(host, { childList: true, subtree: true });
  }

  function boot() { if (drawer()) { watch(); render(); } }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else { boot(); }
  document.addEventListener('shopify:section:load', function () { render(); });
})();

}
